import { RedirectToBiax, SignInRequest } from './types';
import { fetcher } from '@bino/utils/fetcher';

export async function SignIn(bannerId?: string): Promise<void> {
    const signInRequest: SignInRequest = {
        currentUrl: bannerId ? `${window.location.href}?a=${bannerId}` : window.location.href,
    };
    const result = await fetcher.post<RedirectToBiax>('/api/cart/signIn', signInRequest);

    const resultAsRedirect = result;

    if (resultAsRedirect?.url !== undefined && resultAsRedirect?.url !== null) {
        window.location.href = resultAsRedirect.url;
    }
}
